import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { BadgeCheck, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("checking"); // checking | ok | error
  const [msg, setMsg] = useState("");
  const [already, setAlready] = useState(false);

  useEffect(() => {
    if (!token) { setStatus("error"); setMsg("This link is missing its token."); return; }
    api.get("/auth/verify-email", { params: { token } })
      .then(r => { setAlready(!!r.data?.already_verified); setStatus("ok"); })
      .catch(e => { setStatus("error"); setMsg(e.response?.data?.detail || "This link is invalid or expired."); });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F2F4F2] p-8">
      <div className="max-w-sm w-full text-center bg-white rounded-2xl p-8 shadow-sm border border-black/5" data-testid="verify-email-page">
        <img src="/logo-full.png" alt="LIMYA" className="h-8 w-auto mx-auto mb-6"/>
        {status === "checking" && <p className="text-sm text-[#222]/60">Verifying your email…</p>}
        {status === "ok" && (
          <>
            <BadgeCheck size={40} className="text-[#245544] mx-auto mb-3"/>
            <h1 className="text-xl font-bold mb-2" style={{ fontFamily: "Outfit" }}>
              {already ? "Already verified" : "Email verified"}
            </h1>
            <p className="text-sm text-[#222]/60 mb-5" data-testid="verify-email-success">
              {already
                ? "You're all set — this email address was already verified."
                : "Thanks — this is one step toward your Verified Profile badge."}
            </p>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle size={40} className="text-red-500 mx-auto mb-3"/>
            <h1 className="text-xl font-bold mb-2" style={{ fontFamily: "Outfit" }}>Couldn't verify</h1>
            <p className="text-sm text-[#222]/60 mb-5" data-testid="verify-email-error">{msg}</p>
          </>
        )}
        <Link to="/dashboard" className="btn-lime px-5 py-2.5 text-sm inline-block">Go to dashboard</Link>
      </div>
    </div>
  );
}
